/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ControlcenterMelcoModelsUserProductAccess,
    ControlcenterMelcoModelsUserProductAccessFromJSON,
    ControlcenterMelcoModelsUserProductAccessFromJSONTyped,
    ControlcenterMelcoModelsUserProductAccessToJSON,
    ControlcenterMelcoModelsUserRole,
    ControlcenterMelcoModelsUserRoleFromJSON,
    ControlcenterMelcoModelsUserRoleFromJSONTyped,
    ControlcenterMelcoModelsUserRoleToJSON,
} from './';

/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsUserProductPermissions
 */
export interface ControlcenterMelcoModelsUserProductPermissions {
    /**
     * 
     * @type {ControlcenterMelcoModelsUserRole}
     * @memberof ControlcenterMelcoModelsUserProductPermissions
     */
    role?: ControlcenterMelcoModelsUserRole;
    /**
     * 
     * @type {Array<ControlcenterMelcoModelsUserProductAccess>}
     * @memberof ControlcenterMelcoModelsUserProductPermissions
     */
    user_product_access?: Array<ControlcenterMelcoModelsUserProductAccess> | null;
}

export function ControlcenterMelcoModelsUserProductPermissionsFromJSON(json: any): ControlcenterMelcoModelsUserProductPermissions {
    return ControlcenterMelcoModelsUserProductPermissionsFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsUserProductPermissionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsUserProductPermissions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'role': !exists(json, 'role') ? undefined : ControlcenterMelcoModelsUserRoleFromJSON(json['role']),
        'user_product_access': !exists(json, 'user_product_access') ? undefined : (json['user_product_access'] === null ? null : (json['user_product_access'] as Array<any>).map(ControlcenterMelcoModelsUserProductAccessFromJSON)),
    };
}

export function ControlcenterMelcoModelsUserProductPermissionsToJSON(value?: ControlcenterMelcoModelsUserProductPermissions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'role': ControlcenterMelcoModelsUserRoleToJSON(value.role),
        'user_product_access': value.user_product_access === undefined ? undefined : (value.user_product_access === null ? null : (value.user_product_access as Array<any>).map(ControlcenterMelcoModelsUserProductAccessToJSON)),
    };
}


